import type { SxProps } from '@mui/material';

// --- Shared accent palette ---

export const accentColors = {
    info: 'rgba(56, 165, 255, 0.85)',
    warning: 'rgba(255, 167, 38, 0.85)',
    error: 'rgba(244, 67, 54, 0.85)',
    success: 'rgba(76, 175, 80, 0.85)',
} as const;

export type AccentColor = (typeof accentColors)[keyof typeof accentColors];

// --- Glass styles ---

export const glassCardSx = (accent?: string): SxProps => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1.5,
    px: 2.5,
    py: 1.5,
    borderRadius: '16px',
    backdropFilter: 'blur(20px)',
    background: 'rgba(0, 0, 0, 0.55)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.08)',
    ...(accent && { borderLeft: `3px solid ${accent}` }),
    color: '#fff',
    minWidth: 280,
});

export const glassChipSx: SxProps = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    px: 2.5,
    py: 1,
    borderRadius: '40px',
    backdropFilter: 'blur(16px)',
    background: 'rgba(0,0,0,0.6)',
    boxShadow: '0 4px 24px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.08)',
    color: '#fff',
};

export const iconWrapSx = (accent: string): SxProps => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: '50%',
    bgcolor: `${accent}22`,
    color: accent,
    flexShrink: 0,
});
